<template>
	<div>
		<el-button @click="showDialog()" type="primary"> 新建折扣</el-button>
		<!-- <el-tree :data="list" node-key="id" default-expand-all :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                    <el-button type="text" size="mini" @click="() => append(data)">
                        Append
                    </el-button>
                    <el-button type="text" size="mini" @click="() => remove(node, data)">
                        Delete
                    </el-button>
                </span>
            </span>
        </el-tree> -->
		<el-row>
			<el-col :span="4">
				<el-table :data="workerData" border
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{ 'text-align': 'center' }" @row-click="workerNameClick"
					:row-class-name="tableRowClassWorkerName">
					<el-table-column label="发型师" prop="workerName"></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="4">
				<el-table :data="storeData" border
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{ 'text-align': 'center' }" @row-click="storeRowClick"
					:row-class-name="tableRowClassStoreName">
					<el-table-column label="门店" prop="storeName"></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="6">
				<el-table :data="serviceData" border
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{ 'text-align': 'center' }" @row-click="serviceRowClick"
					:row-class-name="tableRowClassServiceName">
					<el-table-column label="服务 状态 操作" prop="serviceName">
						<template slot-scope="{row}">
							<div style="display:flex;">
								<div style="width:100px">{{row.id}}{{row.serviceName}}</div>
								<div style="width:100px">{{ row.status === 0 ? '关闭' : '开启' }}</div>
								<div type='button' style="color: #00aaff;width:100px" @click="showDialog(row)">编辑</div>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作">
						<template slot-scope="{row}">
							<div style="display:flex;justify-content: space-evenly;">
								
								<div type='button' style="color: red;">删除</div>
							</div>
						</template>
					</el-table-column> -->
				</el-table>
			</el-col>
			<el-col :span="10">
				<el-table :data="discountData" border
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{ 'text-align': 'center' }" :row-class-name="tableRowClassDiscountData">
					<el-table-column label="抵扣金额 时间 " prop="serviceName">
						<template slot-scope="{row}">
							<div style="display:flex;">
								<div style="width:80px">{{row.id}}</div>
								<div style="width:200px">{{ row.storeName}}</div>
								<div style="width:100px">{{ row.serviceName}}</div>
								<div style="width:100px">{{ row.discount}}元</div>
								<div style="width:200px">{{ row.date}}</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-dialog title="新增/编辑折扣" :visible.sync="dialog" width="30%">
			<el-form label-width="120px">
				<el-form-item label="状态">
					<el-radio v-model="discount.status" :label="1">开启</el-radio>
					<el-radio v-model="discount.status" :label="0">关闭</el-radio>
				</el-form-item>
				<el-form-item label="发型师">
					<el-select v-model="discount.workerId" collapse-tags placeholder="请选择发型师" v-if="this.add == 1">
						<el-option v-for="item in workerList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<el-input v-model="discount.workerName" style="width: 220px;" v-else disabled></el-input>
				</el-form-item>
				<el-form-item label="折扣门店">
					<el-select v-model="discount.storeId" collapse-tags placeholder="请选择门店" v-if="this.add == 1">
						<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
					<el-input v-model="discount.storeName" style="width: 220px;" v-else disabled></el-input>
				</el-form-item>
				<el-form-item label="折扣项目">
					<el-select v-model="discount.serviceId" collapse-tags placeholder="请选择项目" v-if="this.add == 1">
						<el-option v-for="item in serviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
					<el-input v-model="discount.serviceName" style="width: 220px;" v-else disabled></el-input>
				</el-form-item>
				<el-form-item label="抵扣详情" >
					<el-button @click="addInfoBeanShow()">添加</el-button>
					<div v-for="item in InfoBean" style="padding:10px 0px;border-top: 1px solid #ccc;width:220px">
						<el-date-picker v-model="item.date" type="datetime" placeholder="选择日期时间"
							value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
						<el-input v-model="item.discount" type="number" placeholder="输入抵扣金额"
							style="width: 220px;"></el-input>
						<span style="color: red;margin-left: 180px;" @click="delInfoBean(item)">删除</span>
					</div>
					<div v-if="addShow" style="padding:10px 0px;border-top: 1px solid #ccc;width:220px">
						<el-date-picker v-model="newInfoBean.date" type="datetime" placeholder="选择日期时间"
							value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
						<el-input v-model="newInfoBean.discount" type="number" placeholder="输入抵扣金额"
							style="width: 220px;"></el-input>
						<span style="color: red;margin-left: 150px;" @click="addInfoBean(newInfoBean)">确认添加</span>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="danger" @click="del()">删 除</el-button>
				<el-button type="primary" @click="saveOrUpdare()">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				add: 0,
				list: [], //抵扣列表
				workerData: [], //第一栏
				storeData: [], //第二栏
				serviceData: [], //第三栏
				discountData: [], //第四栏
				storeList: [],
				workerList: [],
				serviceList: [],
				dialog: false, //编辑折扣弹窗
				discount: {}, //折扣信息
				InfoBean: [], //折扣内容信息
				newInfoBean: [], //新添加折扣内容信息
				addShow:false,
			}
		},
		mounted() {
			this.getList()
			this.getWorkerList()
			this.getStoreList()
			this.getServiceList()
		},
		methods: {
			getList() {
				this.$http.get("dWorkerDiscout/list").then(res => {
					if (res.body.code == 200) {
						this.workerData = [] //第一栏
						this.storeData = [] //第二栏
						this.serviceData = [] //第三栏
						this.discountData = [] //第四栏
						this.list = res.body.data
						this.initData() //workerData
						this.storeData = this.workerData[0].storeList //默认第一个发型师
						this.workerData[0].selectWorker = true
						if (this.storeData != null && this.storeData.length > 0) {
							this.storeData.forEach(store => {
								store.selectStore = true //设置底色为选中
								if (store.workerDiscoutList != null && store.workerDiscoutList
									.length > 0) {
									store.workerDiscoutList.forEach(dist => {
										dist.discountsObj = JSON.parse(dist.discounts)
										this.serviceData.push(dist)
										this.serviceData.forEach(service => service.selectService =
											true) //默认初始所有服务被选中，上底色
										if (dist.discountsObj.InfoBean != null && dist
											.discountsObj
											.InfoBean.length > 0) {
											var index = 0
											dist.discountsObj.InfoBean.forEach(info => {
												var tmp = {}
												tmp.index = index++
												tmp.date = info.date
												tmp.discount = info.discount
												tmp.workerName = dist.workerName
												tmp.serviceName = dist.serviceName
												tmp.storeName = dist.storeName
												tmp.workerId = dist.workerId
												tmp.storeId = dist.storeId
												tmp.serviceId = dist.serviceId
												tmp.id = dist.id
												tmp.status = dist.status
												this.discountData.push(tmp)
											})
										}
									})
								}
							})
						}
					}
				});
			},
			initData() {
				if (this.list != null && this.list.length > 0) {
					this.list.forEach(item => {
						this.workerData.push(item)
					})
				}
			},
			// 点击发型师,row单个发型师
			workerNameClick(row) {
				// 其他行底色变白
				this.workerData.forEach(worker => {
					worker.selectWorker = false
				})
				// 当前行变选中
				row.selectWorker = true
				this.storeData = [] //第二栏
				this.serviceData = [] //第二栏
				this.discountData = [] //第三栏
				if (row.storeList != null && row.storeList.length > 0) {
					row.storeList.forEach(store => {
						store.selectStore = true //设置底色为选中
						this.storeData.push(store)
						if (store.workerDiscoutList != null && store.workerDiscoutList.length > 0) {
							store.workerDiscoutList.forEach(dist => {
								this.serviceData.push(dist)
								this.serviceData.forEach(service => service.selectService =
									true) //默认初始所有服务被选中，上底色
								dist.discountsObj = JSON.parse(dist.discounts)
								if (dist.discountsObj.InfoBean != null && dist.discountsObj
									.InfoBean
									.length > 0) {
									var index = 0
									dist.discountsObj.InfoBean.forEach(info => {
										var tmp = {}
										tmp.index = index++
										tmp.date = info.date
										tmp.discount = info.discount
										tmp.workerName = dist.workerName
										tmp.serviceName = dist.serviceName
										tmp.storeName = dist.storeName
										tmp.id = dist.id
										tmp.workerId = dist.workerId
										tmp.storeId = dist.storeId
										tmp.serviceId = dist.serviceId
										tmp.status = dist.status
										this.discountData.push(tmp)
									})

								}
							})
						}
					})
				}
			},
			// 点击门店
			storeRowClick(row, column) {
				this.serviceData = []
				this.discountData = []
				if (row.workerDiscoutList != null && row.workerDiscoutList.length > 0) {
					// 其他行底色变白
					this.storeData.forEach(store => {
						store.selectStore = false
					})
					// 当前行变选中
					row.selectStore = true
					row.workerDiscoutList.forEach(dist => {
						this.serviceData.push(dist)
						this.serviceData.forEach(service => service.selectService = true) //默认初始所有服务被选中，上底色
						dist.discountsObj = JSON.parse(dist.discounts)
						if (dist.discountsObj.InfoBean != null && dist.discountsObj.InfoBean.length > 0) {
							var index = 0
							dist.discountsObj.InfoBean.forEach(info => {
								var tmp = {}
								tmp.index = index++
								tmp.date = info.date
								tmp.discount = info.discount
								tmp.workerName = dist.workerName
								tmp.serviceName = dist.serviceName
								tmp.storeName = dist.storeName
								tmp.workerId = dist.workerId
								tmp.storeId = dist.storeId
								tmp.serviceId = dist.serviceId
								tmp.id = dist.id
								tmp.status = dist.status
								this.discountData.push(tmp)
							})
						}
					})
				}
			},
			// 点击服务
			serviceRowClick(row, column) {
				this.discountData = []
				// if (row.workerDiscoutList != null && row.workerDiscoutList.length > 0) {
				// 其他行底色变白
				this.serviceData.forEach(service => {
					service.selectService = false
				})
				// 当前行变选中
				row.selectService = true
				if (row.discountsObj.InfoBean != null && row.discountsObj.InfoBean.length > 0) {
					var index = 0
					row.discountsObj.InfoBean.forEach(info => {
						var tmp = {}
						tmp.index = index++
						tmp.date = info.date
						tmp.discount = info.discount
						tmp.workerName = row.workerName
						tmp.serviceName = row.serviceName
						tmp.storeName = row.storeName
						tmp.workerId = row.workerId
						tmp.storeId = row.storeId
						tmp.serviceId = row.serviceId
						tmp.id = row.id
						tmp.status = row.status
						this.discountData.push(tmp)
					})
				}
			},
			getWorkerList() {
				var query = "page=0&size=999&status=3"
				this.$http.get("dWorker/queryAll?" + query).then(res => {
					this.workerList = res.body.data.records;
				});
			},
			// 有设置老客优惠的门店
			getStoreList() {
				this.$http.get("store/list").then(res => {
					this.storeList = res.body.data.filter(ele => ele.isOldDiscout == '1');
				})
			},
			//获取服务项目
			getServiceList() {
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify({
					pageNum: 1,
					pageSize: 100
				})).then(res => {
					this.serviceList = res.body.data.records.filter(ele => ele.remove == 0);
				})
			},
			// 设置第一栏底色
			tableRowClassWorkerName({
				row,
				rowIndex
			}) {
				if (row.selectWorker == true) {
					return 'success-row';
				}
				return '';
			},
			// 设置第二栏底色
			tableRowClassStoreName({
				row,
				rowIndex
			}) {
				if (row.selectStore == true) {
					return 'success-row';
				}
				return '';
			},
			// 设置第三栏底色
			tableRowClassServiceName({
				row,
				rowIndex
			}) {
				if (row.selectService == true) {
					return 'success-row';
				}
				return '';
			},
			// 设置第三栏底色
			tableRowClassDiscountData({
				row,
				rowIndex
			}) {
				if (row.status === 0) {
					return 'danger-row';
				} else if (row.status === 1) {
					return 'success-row';
				}
				return '';
			},
			// 编辑修改老客折扣 弹窗
			showDialog(row) {
				this.dialog = true
				if (row) {
					this.discount = row
					this.InfoBean = row.discountsObj.InfoBean
				} else {
					this.InfoBean = []
					this.discount = {
						status: 1,
					}
					this.add = 1
				}
			},
			saveOrUpdare() {
				var a = {}
				var b = {
					InfoBean: []
				}
				var c = {
					date: this.discount.date,
					discount: this.discount.discount
				}
				a.workerId = this.discount.workerId
				a.storeId = this.discount.storeId
				a.serviceId = this.discount.serviceId
				a.status = this.discount.status
				b.InfoBean = this.InfoBean
				a.discounts = JSON.stringify(b)
				if (this.discount.id) {
					a.id = this.discount.id
				} else {
					a.id = 0
				}
				this.$http.post("dWorkerDiscout/saveOrUpdate", a).then(res => {
					if (res.body.code == 1000) {
						this.$message.error(res.body.msg)
					} else if (res.body.code == 200) {
						this.$message.success("修改成功")
					}
					this.getList()
					this.dialog = false
				})
			},
			// 删除整条workerDiscount记录
			del() {
				this.$http.post("dWorkerDiscout/del?id="+ this.discount.id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("删除成功")
					}
					this.getList()
					this.dialog = false
				})
			},
			// 删除抵扣节点
			delInfoBean(item){
				this.InfoBean = this.InfoBean.filter(ele=>ele.date!=item.date)
			},
			//显示添加抵扣节点输入框
			addInfoBeanShow(){
				this.addShow = true
				this.newInfoBean = {
					date:'',
					discount:'',
				}
			},
			// 添加抵扣节点
			addInfoBean(item){
				this.InfoBean.push(item)
				this.addShow = false
			},
			//  getSpanArr(data) {
			// 	 this.spanArr = []
			//             this.pos = 0
			//             for (let i = 0; i < data.length; i++) {
			//                 if (i === 0) {
			//                     // 如果是第一条记录（即索引是0的时候），向数组中加入１
			//                     this.spanArr.push(1)
			//                      this.pos = 0 
			//                 } else {
			//                     if (data[i].id === data[i-1].id) {
			//                         // 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变）
			//                         this.spanArr[ this.pos] += 1
			//                         // this.spanArr.push(0)
			//                     } else {
			//                         // 不相等push 1
			//                         this.spanArr.push(1)
			//                          this.pos ++;
			//                     }
			// 					// this.spanArr.push(0)
			//                 }
			//             }
			// 			console.log(this.spanArr)
			//         },
			// objectSpanMethod({row, column, rowIndex, columnIndex}) {
			// 		   // 用于设置要合并的列 0 表示第一列
			// 		   // 名称 跨行显示
			// 		   if ([0].includes(columnIndex)) {
			// 		   						   const cRow = this.spanArr[rowIndex]
			// 		   						   const cCol = cRow > 0 ? 1 : 0
			// 		   						   return {
			// 		   							   rowspan: cRow, // 合并的行数
			// 		   							   colspan: 1 // 合并的列数，为0表示不显示
			// 		   						   }
			// 		   }
			// 		   // if ([1].includes(columnIndex)) {
			// 		   // 						   const cRow = this.spanArr[rowIndex]
			// 		   // 						   const cCol = cRow > 0 ? 1 : 0
			// 		   // 						   return {
			// 		   // 							   rowspan: cRow, // 合并的行数
			// 		   // 							   colspan: cCol // 合并的列数，为0表示不显示
			// 		   // 						   }
			// 		   // }
			// 	   }
			// // getSpanArr(list) {
			// // 	list.forEach(item => {
			// // 		item.rowspan = 1;
			// // 		item.rowspan1 = 1;
			// // 	})
			// // 	for (let i = 0; i < list.length; i++) {
			// // 		for (let j = i + 1; j < list.length; j++) {
			// // 			if (list[i].id == list[j].id) {
			// // 				list[i].rowspan1++;
			// // 				list[j].rowspan1--;
			// // 			}
			// // 		}
			// // 		i = i + list[i].rowspan - 1;
			// // 		i = i + list[i].rowspan1 - 1;
			// // 	}
			// // 	data.value = list
			// // }
		}
	}
</script>
<style lang="less" scoped>
	/deep/ .el-table__expanded-cell {
		padding: 0;
		margin: -10px 10px 0 10px;
	}

	/deep/ .el-table .danger-row {
		background: rgba(253, 226, 226, 0.4);
	}

	/deep/ .el-table .success-row {
		background: rgba(225, 243, 216, 0.4);
	}
</style>